<template>
	<div ref="tabs-container" class="tabs__container" :class="variant">
		<div v-show="tabs.length > 1" class="tabs__controls">
			<div
				class="tabs__list"
				role="tablist"
				:style="{ backgroundColor: bgColor }"
			>
				<span v-if="variant === 'toggle'" ref="pill" class="tabs__pill"></span>

				<button
					v-for="(tab, index) in tabs"
					:key="index"
					class="tab__button"
					role="tab"
					:aria-selected="tab.isActive ? 'true' : 'false'"
					:data-gtm="tab.gtm"
					:data-ga4="tab.ga4"
					:class="{ 'is-active': tab.isActive }"
					@click="changeTab(tab, index)"
					@keyup.space="changeTab(tab, index)"
				>
					<component :is="tab.icon" />
					<span class="tab__button-title">{{ tab.name }}</span>
				</button>
			</div>
		</div>

		<div class="tabs__content">
			<slot></slot>
		</div>

		<div
			v-if="hasTabRescue && tabs.length > 1"
			class="tabs__type-toggle-rescue"
		>
			<default-button
				:click-handler="onSwitchTicketTypeClick"
				color="purple"
				icon="arrow-right-outline"
				:label="computedTabRescueLabel"
			></default-button>
		</div>
	</div>
</template>

<script>
import DefaultButton from '../DefaultButton';
import Ticket from '@/brands/b2c/svg/ticket-outline.svg';
import Deals from '@/brands/b2c/svg/deals.svg';

export default {
	components: {
		DefaultButton,
		Ticket,
		Deals,
	},

	props: {
		variant: { type: String, required: true },
		hasTabRescue: { type: Boolean, default: false },
		tabRescueLabel: { type: String, default: '' },
		bgColor: { type: String, required: false, default: '#e9e9e9' },
		tabRescueTopOffset: { type: Number, default: 75 },
	},

	data() {
		return {
			tabs: [],
			selectedTabIndex: 0,
		};
	},

	computed: {
		tabWidth() {
			return 100 / this.tabs.length;
		},

		computedTabRescueLabel() {
			const labelSplit = this.tabRescueLabel.split('{0}');
			// prettier-ignore
			const nextTabIndex = this.selectedTabIndex < this.tabs.length - 1 ? this.selectedTabIndex + 1 : 0;
			const nextTabName = this.tabs[nextTabIndex].name;

			return `${labelSplit[0]}${nextTabName}${labelSplit[1]}`;
		},
	},

	mounted() {
		this.updateTabList();

		this.tabs.forEach((tab, index) => {
			if (tab.selected) {
				this.selectedTabIndex = index;
			}
		});

		if (this.variant === 'toggle') {
			this.$refs.pill.style.width = `${this.tabWidth}%`;
			this.$refs.pill.style.left = `${this.selectedTabIndex * this.tabWidth}%`;
		}
	},

	methods: {
		changeTab(chosenTab, index) {
			this.selectedTabIndex = index;

			this.tabs.forEach((tab) => {
				tab.isActive = tab.name == chosenTab.name;
			});

			if (this.variant === 'toggle') {
				this.$refs.pill.style.left = `${index * this.tabWidth}%`;
			}
		},

		updateTabList() {
			if (this.$children.length <= 0) {
				return;
			}

			const tabList = this.$children.reduce(function (list, currentValue) {
				if (currentValue.$options.name === 'DefaultTab') {
					list.push(currentValue);
				}

				return list;
			}, []);

			this.tabs = tabList;
		},

		onSwitchTicketTypeClick() {
			// prettier-ignore
			window.scroll(0, this.$refs['tabs-container'].offsetTop - this.tabRescueTopOffset);

			// prettier-ignore
			setTimeout(function() {
				// added the timeout to let user see the tab change at the top
				// prettier-ignore
				const newActiveIndex = (this.selectedTabIndex === this.tabs.length - 1)? 0 : this.selectedTabIndex + 1;
				this.changeTab(this.tabs[newActiveIndex], newActiveIndex);
			}.bind(this), 320);
		},
	},
};
</script>

<style lang="scss">
.tabs__container {
	scroll-behavior: smooth;
}
</style>
